// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://gprdqiyuvginvtkowgmf.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdwcmRxaXl1dmdpbnZ0a293Z21mIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI4NzA2MzAsImV4cCI6MjA4ODQ0NjYzMH0.yyUWUqDmgWPwdnYrvyn-qs9ku9Vq_JruRjuStXgLWy8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});